import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDictionary } from "../../contexts/dictionary";
import { tr } from "date-fns/locale";


export const menuItems: MenuItem[] = [
  {
    type: "link",
    label: 'our_services',
    to: "/services",
  },
  {
    type: "subMenu",
    label: 'medicine_at_home',
    to: "/doctor",
    items: [
      {
        label: 'doctor_to_the_house',
        to:"/doctor-to-home"
      },
      {
        label: 'nurse_to_the_house',
        to:"/nurse-to-home"
      },
    ]
  },
  {
    type: "link",
    label: 'contact_us',
    to: "/contactus",
  }
];


const NavLinks = () => {

  const {translate} = useDictionary();






  

  const [isSideMenu, setSideMenu] = useState<string>("");
 
  const onhandleCloseMenu = () => {
    var root = document.getElementsByTagName("html")[0];
    root.classList.remove("menu-opened");
  };

  const toggleSidebar = (value:string) => {
    setSideMenu(value);
  };


  
const LinkMenu = ({ item }:{item:MenuItem}) => {
  const {translate} = useDictionary();
  const location = useLocation();
  return (
    <li className={`has-submenu ${location.pathname.includes(item.to) ? "active" : ""}`}>
    <Link to={item.to}>{translate(item.label)}</Link>
  </li>
  );
}

const SubMenu = ({ menu }:{menu:MenuItem}) => {
  const location = useLocation();
  const {translate} = useDictionary();
  return (
        <li className={`has-submenu ${location.pathname.includes(menu.to) ? "active" : ""}`}>
        <Link
          to="#"
          className={isSideMenu == menu.to ? "subdrop " : ""}
          onClick={() =>
            toggleSidebar(isSideMenu == menu.to ? "submenu" : menu.to)
          }
    
        >
          {translate(menu.label)} <i className="fas fa-chevron-down" />
        </Link>
        {isSideMenu == menu.to ? (
         <>
         <ul  className={`${
              isSideMenu == menu.to ? "submenu d-block" : "submenu"
            }`}>
          {menu && menu.items?.map((item, index) => {
            return (
              <li key={index} className={""}>
                <Link to={item.to} onClick={() => onhandleCloseMenu()}>
                  {translate(item.label)}
                </Link>
              </li>
            );
          })}
        </ul>
      
         </>
        ) : (
          ""
        )}
      </li>
    
  );
}

  return (
    <>
      {menuItems.map((item, index) => {
       
        if(item.type === "subMenu"){
       
          return (
            <SubMenu menu={item} key={index} />
          )
          
        } else {
          return (
            <LinkMenu item={item} key={index} />  
          )
          
        }
      
      })}
    </>
  
  );
};

export default NavLinks;
